<script>
import _ from 'lodash'

import {
  chunkIsSelected,
  getChunkClasses,
  getFlagOptions,
  tagAsFalseJustification,
  tagAsLegitJustification,
  toggleFalseJustificationTypes
} from '../chunkJustifications'
import { getHealthDataLabel } from './documentLabels'

export default {
  props: {
    textualHealthEntries: { type: Array, required: true },
    type: { type: String, required: true },
    selection: { type: Object, default: null },
    scrollTarget: { type: Object, default: null },
    isDocumentSource: { type: Boolean, required: false },
    // Redundant with the same feature in the justification popin (ApiJustificationSummary.vue),
    // which already handles it — disabled by default until BUILD-733's follow-up ticket settles
    // where the underlying data should live long-term.
    enableFalseJustificationFeatures: { type: Boolean, default: false },
  },
  emits: ['disable-justification-scrolling'],
  data() {
    return {
      showFalseJustificationTypes: {},
    }
  },
  mounted() {
    if (this.scrollTarget) {
      this.$nextTick(this.scrollToChunk)
    }
  },
  beforeUpdate() {
    if (this.scrollTarget) {
      this.$nextTick(this.scrollToChunk)
    }
  },
  methods: {
    getHealthDataLabel(type) {
      return getHealthDataLabel(type)
    },
    getChunkClasses(chunk, selection) {
      return getChunkClasses(chunk, selection)
    },
    getFlagOptions(chunk) {
      return getFlagOptions(chunk)
    },
    tagAsFalseJustification({ report, healthEntry, chunk, errorType, origin }) {
      this.showFalseJustificationTypes[chunk.hash] = tagAsFalseJustification(report, healthEntry, chunk, errorType, origin, this.$store)
    },
    tagAsLegitJustification({ report, healthEntry, chunk }) {
      this.showFalseJustificationTypes[chunk.hash] = tagAsLegitJustification(report, healthEntry, chunk, this.$store)
    },
    toggleFalseJustificationTypes(chunk) {
      if (this.enableFalseJustificationFeatures) {
        toggleFalseJustificationTypes(chunk, this.showFalseJustificationTypes)
      }
    },
    scrollToChunk() {
      const scrollTarget = this.scrollTarget
      let selectedChunk = null
      let hash = null

      if (scrollTarget && scrollTarget.offset !== null) {
        const targetEntry = this.textualHealthEntries.find((healthEntry) => healthEntry.id === scrollTarget.docId)
        if (targetEntry) {
          selectedChunk = targetEntry.chunks.find(
            (chunk) => chunk.chunkStart <= scrollTarget.offset && scrollTarget.offset < chunk.chunkEnd
          ) || null
        }
      }

      if (selectedChunk === null) {
        _.forEach(this.textualHealthEntries, (healthEntry) => {
          if (this.type === healthEntry.type) {
            _.forEach(healthEntry.chunks, (chunk) => {
              if ((selectedChunk === null && chunk.isHighlighted) || chunkIsSelected(chunk, this.selection)) {
                selectedChunk = chunk
              }
            })
          }

        })
      }

      if (selectedChunk !== null) {
        hash = parseInt(selectedChunk.hash)
      }

      if (this.$refs[hash] && selectedChunk !== null) {
        const chunkPosition = window.pageYOffset + this.$refs[hash][0].getBoundingClientRect().top
        const margin = window.innerHeight / 2
        scroll({ top: chunkPosition - margin, behavior: 'smooth' })
      }

      this.$emit('disable-justification-scrolling')

    },
  }
}
</script>

<template>
  <div :class="{'highlight-on-click' : isDocumentSource }">
    <div class="card-body">
      <h1 class="report-title">
        {{ getHealthDataLabel(type) }}
      </h1>
    </div>
    <div class="card-body">
      <table class="table">
        <thead>
          <tr>
            <th>Date</th>
            <th>Contenu</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="healthEntry in textualHealthEntries"
            :key="healthEntry.id"
          >
            <td>{{ healthEntry.creationDate ? healthEntry.creationDate.format('L') : '-' }}</td>
            <td v-if="healthEntry.chunks">
              <span
                v-for="chunk in healthEntry.chunks"
                :key="chunk.hash"
                :ref="chunk.hash"
                :class="getChunkClasses(chunk, selection)"
                class="text-data-content"
                @click="toggleFalseJustificationTypes(chunk)"
              >{{ chunk.string }}<!--  Comments are here to avoid whitespace issues
              --><v-dropdown
                  v-if="(chunk.isHighlighted || chunk.isFalseJustification)"
                  :shown="showFalseJustificationTypes[chunk.hash]"
                  placement="bottom-start"
                  class="popover-container popover-container__invisible"
                  @auto-hide="() => showFalseJustificationTypes[chunk.hash] = false"
                ><!--
              --><template #popper>
                    <span
                      v-if="!chunk.isFalseJustification"
                    >
                      Signaler comme :
                      <div
                        v-for="option in getFlagOptions(chunk)"
                        :key="option.key"
                      >
                        <button
                          class="btn btn-link btn-sm"
                          @click="tagAsFalseJustification({ errorType: option.errorType, origin: option.origin, report : null, healthEntry: healthEntry, chunk })"
                        >
                          {{ option.label }}
                        </button>
                      </div>
                    </span>
                    <span
                      v-else
                    >
                      <button
                        class="btn btn-link btn-sm"
                        @click="tagAsLegitJustification({ report: null, healthEntry: healthEntry, chunk })"
                      >
                        Annuler le signalement
                      </button>
                    </span>
                  </template><!--
              --></v-dropdown><!--
            --></span>
            </td>
            <td v-else>
              <span class="text-data-content">{{ healthEntry.content }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<style scoped lang="scss">
h1 {
  font-size: 1.5rem;
}
</style>
